<template>
    <ProductZoomer
            :base-images="images"
            :base-zoomer-options="zoomerOptions"
    />
</template>

<script>
    export default {
        name: "gallery",
        props: ['image1', 'image2'],
        data() {
            return {
                'images': {
                    'thumbs': [
                        {
                            'id': 1,
                            'url': this.image1
                        },
                        {
                            'id': 2,
                            'url': this.image2
                        }
                    ],
                    'normal_size': [
                        {
                            'id': 1,
                            'url': this.image1
                        },
                        {
                            'id': 2,
                            'url': this.image2
                        }
                    ],
                    'large_size': [
                        {
                            'id': 1,
                            'url': this.image1
                        },
                        {
                            'id': 2,
                            'url': this.image2
                        }
                    ]
                },
                'zoomerOptions': {
                    'zoomFactor': 1,
                    'pane': 'container',
                    'hoverDelay': 300,
                    'namespace': 'container-zoomer',
                    'move_by_click': true,
                    'scroll_items': 4,
                    'choosed_thumb_border_color': "#8ac6c4"
                }
            }
        }
    }
</script>

<style scoped>

</style>